import { commonAttributes, getAttributes, getAttrs, hasAttrs, hole, tagMark } from "./editor.marks";

/**
 * Object defining various marks for the editor.
 * Each mark specifies its attributes, parsing logic, and rendering logic.
 * @type {Object}
 * @author Shivam Mishra
 */
export const editorMarks = {
  link: {
    attrs: {
      ...commonAttributes(),
      href: { default: null },
      title: { default: null },
    },
    inclusive: false,
    parseDOM: [{ tag: "a", getAttrs: getAttributes }],
    toDOM(node) {
      let oldHref = node.attrs.href;
      let isSameURL = false;
      try {
        const linkOrigin = new URL(oldHref).origin;
        isSameURL = linkOrigin === window.location.origin;
      } catch (e) {
        // If URL parsing fails, assume it's not the same origin
        isSameURL = false;
      }
      let newHref =
        oldHref?.indexOf("https://") >= 0 || oldHref?.indexOf("http://") >= 0 || oldHref?.match(/mailto:/) ? oldHref : "https://" + oldHref;
      return ["a", getAttrs({ ...node.attrs, href: newHref, target: isSameURL ? "_top" : "_blank" }, false), hole];
    },
  },
  ...tagMark("strong"),
  ...tagMark("b"),
  ...tagMark("em"),
  ...tagMark("u"),
  ...tagMark("del"),
  ...tagMark("sub"),
  ...tagMark("sup"),
  ...tagMark("code"),
  style: {
    attrs: {
      ...commonAttributes(),
    },
    parseDOM: [
      {
        tag: "span",
        getAttrs: getAttributes,
      },
    ],
    toDOM: (node) => (hasAttrs(node.attrs, false) ? ["span", getAttrs(node.attrs, false), hole] : ["span", hole]),
  },
  ychange: {
    attrs: {
      user: { default: null },
      type: { default: null },
      color: { default: null },
    },
    inclusive: false,
    parseDOM: [{ tag: "ychange", getAttrs: getAttributes }],
    toDOM: (node) => (hasAttrs(node.attrs, false) ? ["ychange", getAttrs(node.attrs, false), hole] : ["ychange", hole]),
  },
};
